var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoryMobileLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mobile_Logo",
    "data-name": "Mobile Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.289,
    height: 15.996,
    viewBox: "0 0 169.289 15.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M0,4.155a3.227,3.227,0,0,1,1.524-.376H3.69V17.257H6.209a3.235,3.235,0,0,1-.376-1.547V3.779H8a3.222,3.222,0,0,1,1.524.376V1.79H0V4.154Z",
    transform: "translate(0 -1.525)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M137.873,1.79h-2.519a3.253,3.253,0,0,1,.376,1.547V7.6h-8.551V1.79H124.66a3.253,3.253,0,0,1,.376,1.547V17.257h2.519a3.252,3.252,0,0,1-.376-1.547V9.591h8.551v7.668h2.519a3.235,3.235,0,0,1-.376-1.547Z",
    transform: "translate(-106.21 -1.525)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M280.174,3.337V17.257h8.6V14.892a3.252,3.252,0,0,1-1.547.376h-4.9V9.391h6.451V7.4h-6.451V3.779h4.927a3.226,3.226,0,0,1,1.524.376V1.79H279.8a3.253,3.253,0,0,1,.376,1.547Z",
    transform: "translate(-238.39 -1.525)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M487.746,3.779a3.226,3.226,0,0,1,1.524.376V1.79H480.3a3.236,3.236,0,0,1,.376,1.547V17.257h8.594V14.892a3.252,3.252,0,0,1-1.547.376h-4.906V9.391h6.451V7.4h-6.451V3.779Z",
    transform: "translate(-409.216 -1.525)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M625.313,17.257a3.235,3.235,0,0,1-.376-1.547V1.79h-3.182l-4.242,13.191L613.271,1.79h-3.6a3.253,3.253,0,0,1,.376,1.547V17.257h2.474a3.236,3.236,0,0,1-.376-1.547V4.464L616.3,17.257h2.409L622.84,4.464V17.257h2.475Z",
    transform: "translate(-519.439 -1.525)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M779.133,0a7.77,7.77,0,0,0-7.954,8,7.954,7.954,0,1,0,15.909,0A7.77,7.77,0,0,0,779.133,0Zm0,14.008c-3.358,0-5.744-2.43-5.744-6.01s2.386-6.01,5.744-6.01,5.745,2.43,5.745,6.01S782.493,14.008,779.133,14.008Z",
    transform: "translate(-657.045)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M950.188,15.719l-3.623-6.164c2.3-.176,4.021-1.5,4.021-3.845,0-2.519-1.988-3.91-4.529-3.91H940.49a3.252,3.252,0,0,1,.376,1.547V17.267h2.519a3.253,3.253,0,0,1-.376-1.547V9.579h1.126l4.486,7.689h2.85a6.3,6.3,0,0,1-1.282-1.547Zm-7.181-8.042V3.7h3.071c1.326,0,2.3.663,2.3,1.989s-.972,1.989-2.3,1.989Z",
    transform: "translate(-801.297 -1.534)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M1067.305,9.656l5.06-7.866h-2.606a4.634,4.634,0,0,1-.663,1.391l-2.806,4.353L1062.6,1.79h-2.651a6.152,6.152,0,0,1,1.082,1.458l4.132,6.407v7.6h2.519a3.255,3.255,0,0,1-.376-1.547V9.655Z",
    transform: "translate(-903.077 -1.525)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoryMobileLogo1);
export default __webpack_public_path__ + "static/media/emory-mobile-logo1.f1dd6100647f7f8e1adbd36a9086afd9.svg";
export { ForwardRef as ReactComponent };